export default __webpack_public_path__ + "static/media/Privacy Policy.59f2de66.pdf";